import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import BsModal from "../../Misc/BsModal";

export default class PasswordChange extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      password: "",
      passwordConfirm: "",
      passwordCurrent: "",
    };
  }

  onChange = (id, value) => {
    this.setState((state) => {
      state[id] = value;
      return state;
    });
  };

  save = async () => {
    const { password, passwordConfirm, passwordCurrent } = this.state;
    if (!password) {
      this.context.toast("Укажите пароль", "error");
      return;
    }
    if (password !== passwordConfirm) {
      this.context.toast("Пароль и подтверждение не совпадают", "error");
      return;
    }
    this.setState({ pending: true });

    let saveData = {
      oldpass: passwordCurrent,
      newpass: password,
    };
    let result = await this.context.api.q("/user/password", saveData);
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      document.location.reload();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    const { passwordchange, passwordnotchange } = this.props;
    const { password, passwordConfirm, passwordCurrent } = this.state;

    return (
      <>
        <BsModal center {...this.props}>
          <Blocker on={this.state.pending}>
            {passwordnotchange && (
              <div className="alert bg-light-warning text-warning  text-center">
                Администратор установил для вас запрет смены пароля
              </div>
            )}
            {passwordchange && !passwordnotchange && (
              <div className="alert bg-light-warning text-warning text-center">
                Администратор установил для вас необходимость смены пароля
              </div>
            )}
            {!passwordnotchange && (
              <div>
                <div className="form-group">
                  <label>Текущий пароль или секретный код:</label>
                  <input
                    type="password"
                    className="form-control mb-3"
                    value={passwordCurrent}
                    onChange={(e) =>
                      this.onChange("passwordCurrent", e.target.value)
                    }
                    onKeyPress={(e) => {
                      if (e.key === "Enter") this.save();
                    }}
                  />
                  <div className="small text-muted">
                    * Если вы не помните свой текущий пароль, вы можете указать
                    в этом поле секретный код, высланный вам при регистрации
                  </div>
                </div>
                <div className="form-group">
                  <label>Новый пароль:</label>
                  <input
                    type="password"
                    className="form-control mb-3"
                    value={password}
                    onChange={(e) => this.onChange("password", e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") this.save();
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>Повтор пароля:</label>
                  <input
                    type="password"
                    className="form-control mb-3"
                    value={passwordConfirm}
                    onChange={(e) =>
                      this.onChange("passwordConfirm", e.target.value)
                    }
                    onKeyPress={(e) => {
                      if (e.key === "Enter") this.save();
                    }}
                  />
                </div>
                <div className="mt-5 pt-5 border-top">
                  <button className="btn btn-primary mr-2" onClick={this.save}>
                    Сохранить
                  </button>
                  <button
                    className="btn btn-light mr-2"
                    onClick={() => this.props.onClose()}
                  >
                    Отмена
                  </button>
                </div>
              </div>
            )}
          </Blocker>
        </BsModal>
      </>
    );
  }
}
